import { Stack, StackProps } from '@mui/material'

export const StackForm = (stackProps: StackProps): JSX.Element => (
  <Stack
    {...stackProps}
    direction='row'
    sx={{
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 2,
      pt: 1,
      ...stackProps.sx,
    }}
  />
)
